import $ from 'jquery';
import gsap from 'gsap';

class BannerAnimationItem {
    constructor(el, index) {
        this.render(el, index);
    }

 

    animate() {
        var tl = new gsap.timeline();
        tl.set(this.background, { opacity: 0.0 });

        tl.to(this.background, { opacity: 1, duration: 0.4, ease: "power3.out", delay: 1 });
        tl.fromTo(this.pillar, { y: '100%' }, { opacity: 1, y: 0, ease: "power3.out", duration: 0.4 });
        tl.fromTo(this.text, { y: '50', opacity: 0 }, { opacity: 1, ease: "power3.out", y: 0, duration: 0.4, stagger: 0.2  });
        tl.fromTo(this.pulser, { y: '50', opacity: 0 }, { opacity: 1, y: 0, ease: "power3.out", duration: 0.4  }, ">-0.4")
    }

    render(el, index) {
        this.element = $(el);

        this.background = this.element.find('[data-ref="banner-background"]');
        this.pillar = this.element.find('[data-ref="banner-pillar"]');
        this.text = this.element.find('[data-ref="banner-text"]');
        this.pulser = this.element.find('[data-ref="banner-pulser"]');


 

        this.animate();
    }
}

class BannerAnimation {
    static get EVENT() {
        return {

        }
    }

    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    render(el, index) {
        new BannerAnimationItem(el, index);
    }
}

export default BannerAnimation;